import React, { useState } from "react";

export default function SimpleCarousel({ items, width = "min(1080px, 100%)", height = "100%" }) {
  const [index, setIndex] = useState(0);

  if (!items || items.length === 0) return <div>No media</div>;

  const prev = () => setIndex((index - 1 + items.length) % items.length);
  const next = () => setIndex((index + 1) % items.length);

  return (
    <div style={{ position: "relative", width, height }}>
      {items.map((item, i) => (
        <div
          key={i}
          style={{
            display: i === index ? "block" : "none",
            width: "100%",
            height: "100%",
            alignContent: "center"
          }}
        >
          {item.type === "image" ? (
            <img
              src={item.src}
              alt={item.alt || ""}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                border: "black solid"
              }}
            />
          ) : (
            <video
              src={item.src}
              poster={item.poster}
              autoPlay={item.autoPlay || false}
              loop={item.loop || false}
              muted={item.muted || false}
              controls={item.controls !== undefined ? item.controls : false}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          )}
        </div>
      ))}

      {/* Only show arrows if more than one item */}
      {items.length > 1 && (
        <>
          <button onClick={prev} aria-label="Previous" style={arrowStyle("left")}>
            <ArrowLeftIcon />
          </button>
          <button onClick={next} aria-label="Next" style={arrowStyle("right")}>
            <ArrowRightIcon />
          </button>
        </>
      )}
    </div>
  );
}

function arrowStyle(side) {
  return {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    [side]: "65px",
    width: "65px",
    height: "65px",
    borderRadius: "50%",
    border: "none",
    background: "rgba(0,0,0,0.4)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    userSelect: "none"
  };
}

function ArrowLeftIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}
